/** @type {Map<string, CSSStyleSheet>} */
export const CSSCache = new Map();
/** @type {Map<string, HTMLTemplateElement>} */
export const HTMLCache = new Map();
